import { BaseCustomizableChartService } from "@common-modules/shared/charts/base-customizable-chart.service";
import { IChartConfiguration } from "@common-modules/shared/charts/model/chart/ichart-configuration";
import { WlmElementExtended } from "@common-modules/shared/charts/model/elements/element-extended";
import { Observable } from "rxjs";

export class CTCustomizableChartService extends BaseCustomizableChartService {
    getChartConfiguration(workspaceName: string, elements: WlmElementExtended[]): Observable<IChartConfiguration> {
        throw new Error("Method not implemented.");
    }
    updateChartConfiguration(chartConfiguration: IChartConfiguration): Observable<IChartConfiguration> {
        throw new Error("Method not implemented.");
    }
}